<template>
  <ElDropdown
    :hide-timeout="50"
    :show-timeout="0"
    trigger="hover"
    class="select"
    placement="bottom-start"
    popper-class="ddgroup ddgroup-new"
    @command="command"
    @visible-change="visibleChange"
  >
    <div
      :class="{active : activeClass || isDropped}"
      class="select-link"
    >
      <span
        class="text"
        @click.prevent="handlerClick"
      ><slot /></span>
      <UiIcon
        class="chev-d"
        name="chevron-down"
        size="8px"
      />
    </div>
    <template v-slot:dropdown>
      <ElDropdownMenu class="ddgroup ddgroup-new">
        <ElDropdownItem
          v-for="field in allDimensionsFilter"
          :key="field.name"
          :command="field"
          :class="{selected : groupingSelects[typeGroup] && groupingSelects[typeGroup].name === field.name}"
          class="grouping_select_item"
        >
          {{ field.title }}
        </ElDropdownItem>
      </ElDropdownMenu>
    </template>
  </ElDropdown>
</template>

<script>

export default {
  name: 'GroupingDropdown',
  props: {
    groupingSelects: {
      type: Object,
      required: true,
    },

    activeClass: {
      type: [Object, String, Array],
      default() {
        return null;
      },
    },

    allDimensionsFilter: {
      type: [Array, Object],
      required: true,
    },

    typeGroup: {
      type: String,
      required: true,
    },
  },
  emits: ['handlerClick', 'visibleChange', 'command'],

  data() {
    return {
      isDropped: false,
    };
  },

  methods: {
    command(gb, block) {
      this.$emit('command', gb, block);
    },

    visibleChange(v) {
      this.isDropped = v;
      this.$emit('visibleChange', v);
    },

    handlerClick(e) {
      this.$emit('handlerClick', e);
    },
  },
};
</script>
<style lang="scss">
.el-popper.ddgroup-new{
  margin-top: -12px !important;
  .el-popper__arrow{
    display: none;

  }
}
</style>
